import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnySpend, AnySpendBondKit, AnySpendBuySpin, AnySpendCollectorClubPurchase, AnySpendNFT, AnyspendSignatureMint, AnySpendStakeB3, AnySpendStakeB3ExactIn, AnySpendTournament, OrderHistory } from "../../../anyspend/react/index.js";
import { AnySpendDeposit } from "../../../anyspend/react/components/AnySpendDeposit.js";
import { AnySpendDepositHype } from "../../../anyspend/react/components/AnyspendDepositHype.js";
import { AnySpendCheckoutTrigger } from "../../../anyspend/react/components/checkout/AnySpendCheckoutTrigger.js";
import { AnySpendWorkflowTrigger } from "../../../anyspend/react/components/AnySpendWorkflowTrigger.js";
import { AnySpendDepositUpside } from "../../../anyspend/react/components/AnySpendDepositUpside.js";
import { AnySpendStakeUpside } from "../../../anyspend/react/components/AnySpendStakeUpside.js";
import { AnySpendStakeUpsideExactIn } from "../../../anyspend/react/components/AnySpendStakeUpsideExactIn.js";
import { useB3Config, useIsMobile, useModalStore } from "../../../global-account/react/index.js";
import { cn } from "../../../shared/utils/cn.js";
import { debugB3React } from "../../../shared/utils/debug.js";
import { AnimatePresence, motion } from "framer-motion";
import { AvatarEditor } from "./AvatarEditor/AvatarEditor.js";
import { Deposit } from "./Deposit/Deposit.js";
import { LinkAccount } from "./LinkAccount/LinkAccount.js";
import { LinkNewAccount } from "./LinkAccount/LinkNewAccount.js";
import { ManageAccount } from "./ManageAccount/ManageAccount.js";
import NotificationsContent from "./ManageAccount/NotificationsContent.js";
import SessionDurationContent from "./ManageAccount/SessionDurationContent.js";
import { RequestPermissions } from "./RequestPermissions/RequestPermissions.js";
import { Send } from "./Send/Send.js";
import { SignInWithB3Flow } from "./SignInWithB3/SignInWithB3Flow.js";
import { ToastContainer, useToastContext } from "./Toast/index.js";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "./ui/dialog.js";
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from "./ui/drawer.js";
const debug = debugB3React("B3DynamicModal");
export function B3DynamicModal() {
  const $ = _c(17);
  const isOpen = useModalStore(_temp);
  const setB3ModalOpen = useModalStore(_temp2);
  const contentType = useModalStore(_temp3);
  const navigateBack = useModalStore(_temp4);
  const {
    theme
  } = useB3Config();
  const isMobile = useIsMobile();
  const {
    toasts,
    removeToast,
    headerMode
  } = useToastContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["anySpend", "anySpendNft", "anySpendJoinTournament", "anySpendFundTournament", "anySpendStakeB3", "anySpendStakeB3ExactIn", "anySpendStakeUpside", "anySpendStakeUpsideExactIn", "anySpendBuySpin", "anySpendOrderHistory", "signInWithB3", "anySpendSignatureMint", "anySpendBondKit", "linkAccount", "linkNewAccount", "avatarEditor", "deposit", "send", "notifications", "anySpendDeposit", "anySpendWorkflowTrigger", "anySpendCheckoutTrigger"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const fullWidthTypes = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["anySpendNft", "anySpendJoinTournament", "anySpendFundTournament", "anySpendStakeB3", "anySpendStakeB3ExactIn", "anySpendStakeUpside", "anySpendStakeUpsideExactIn", "anySpendBuySpin", "anySpendSignatureMint", "anySpendBondKit"];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const freestyleTypes = t1;
  let t2;
  if ($[2] !== contentType || $[3] !== headerMode || $[4] !== isMobile || $[5] !== isOpen || $[6] !== navigateBack || $[7] !== removeToast || $[8] !== setB3ModalOpen || $[9] !== theme || $[10] !== toasts) {
    const isAnySpendType = contentType?.type?.toLowerCase().startsWith("anyspend") ?? false;
    const isFreestyleType = freestyleTypes.includes(contentType?.type);
    const isClosable = contentType?.closable !== false;
    const contentClass = cn("b3-modal", theme === "dark" && "dark", fullWidthTypes.includes(contentType?.type) && "w-full", isFreestyleType && "b3-modal-freestyle", contentType?.type === "signInWithB3" && "p-0", contentType?.type === "anySpend" && "md:p-0", contentType?.type === "send" && "p-0", contentType?.type === "manageAccount" && " md:p-0 md:pt-2", contentType?.type === "linkAccount" && "md:p-0", contentType?.type === "anySpendCheckoutTrigger" && "p-0");
    debug("contentType", contentType);
    let t3;
    if ($[12] !== contentType) {
      t3 = () => {
        if (!contentType) {
          return null;
        }
        switch (contentType.type) {
          case "signInWithB3":
            {
              return _jsx(SignInWithB3Flow, {
                ...contentType
              });
            }
          case "requestPermissions":
            {
              return _jsx(RequestPermissions, {
                ...contentType
              });
            }
          case "manageAccount":
            {
              return _jsx(ManageAccount, {
                ...contentType
              });
            }
          case "anySpend":
            {
              return _jsx(AnySpend, {
                mode: "modal",
                ...contentType
              });
            }
          case "anyspendOrderDetails":
            {
              return _jsx(AnySpend, {
                mode: "modal",
                loadOrder: contentType.orderId
              });
            }
          case "anySpendNft":
            {
              return _jsx(AnySpendNFT, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendJoinTournament":
            {
              return _jsx(AnySpendTournament, {
                ...contentType,
                mode: "modal",
                action: "join"
              });
            }
          case "anySpendFundTournament":
            {
              return _jsx(AnySpendTournament, {
                ...contentType,
                mode: "modal",
                action: "fund"
              });
            }
          case "anySpendOrderHistory":
            {
              return _jsx(OrderHistory, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendStakeB3":
            {
              return _jsx(AnySpendStakeB3, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendStakeB3ExactIn":
            {
              return _jsx(AnySpendStakeB3ExactIn, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendStakeUpside":
            {
              return _jsx(AnySpendStakeUpside, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendStakeUpsideExactIn":
            {
              return _jsx(AnySpendStakeUpsideExactIn, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendDepositUpside":
            {
              return _jsx(AnySpendDepositUpside, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendBuySpin":
            {
              return _jsx(AnySpendBuySpin, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendSignatureMint":
            {
              return _jsx(AnyspendSignatureMint, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendBondKit":
            {
              return _jsx(AnySpendBondKit, {
                ...contentType
              });
            }
          case "linkAccount":
            {
              return _jsx(LinkAccount, {
                ...contentType
              });
            }
          case "linkNewAccount":
            {
              return _jsx(LinkNewAccount, {
                ...contentType
              });
            }
          case "anySpendDepositHype":
            {
              return _jsx(AnySpendDepositHype, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendCollectorClubPurchase":
            {
              return _jsx(AnySpendCollectorClubPurchase, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendDeposit":
            {
              return _jsx(AnySpendDeposit, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendWorkflowTrigger":
            {
              return _jsx(AnySpendWorkflowTrigger, {
                ...contentType,
                mode: "modal"
              });
            }
          case "anySpendCheckoutTrigger":
            {
              return _jsx(AnySpendCheckoutTrigger, {
                ...contentType,
                mode: "modal"
              });
            }
          case "avatarEditor":
            {
              return _jsx(AvatarEditor, {
                onSetAvatar: contentType.onSuccess
              });
            }
          case "deposit":
            {
              return _jsx(Deposit, {});
            }
          case "send":
            {
              return _jsx(Send, {
                ...contentType
              });
            }
          case "notifications":
            {
              return _jsx(NotificationsContent, {
                ...contentType
              });
            }
          case "sessionDuration":
            {
              return _jsx(SessionDurationContent, {
                partnerId: contentType.partnerId
              });
            }
          default:
            {
              return null;
            }
        }
      };
      $[12] = contentType;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    const renderContent = t3;
    const ModalComponent = isMobile ? Drawer : Dialog;
    const ModalContent = isMobile ? DrawerContent : DialogContent;
    const ModalTitle = isMobile ? DrawerTitle : DialogTitle;
    const ModalDescription = isMobile ? DrawerDescription : DialogDescription;
    let t4;
    if ($[14] !== isClosable || $[15] !== setB3ModalOpen) {
      t4 = open => {
        if (!open && !isClosable) {
          return;
        }
        setB3ModalOpen(open);
      };
      $[14] = isClosable;
      $[15] = setB3ModalOpen;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    const handleOpenChange = t4;
    t2 = _jsxs(ModalComponent, {
      open: isOpen,
      onOpenChange: handleOpenChange,
      children: [_jsxs(ModalContent, {
        className: cn(contentClass, "rounded-2xl bg-white shadow-xl dark:bg-neutral-900", "border border-gray-200 dark:border-neutral-800", (contentType?.type === "manageAccount" || contentType?.type === "deposit" || contentType?.type === "send" || contentType?.type === "avatarEditor" || contentType?.type === "notifications") && "p-0", "mx-auto w-full max-w-md sm:max-w-lg"),
        hideCloseButton: true,
        hideGABranding: isAnySpendType,
        onEscapeKeyDown: !isClosable ? _temp5 : undefined,
        children: [_jsx(ModalTitle, {
          className: "sr-only hidden",
          children: contentType?.type || "Modal"
        }), _jsx(ModalDescription, {
          className: "sr-only hidden",
          children: contentType?.type || "Modal Body"
        }), _jsxs("div", {
          className: cn("b3-modal-content no-scrollbar dark:bg-b3-background flex max-h-[90dvh] flex-col overflow-auto sm:max-h-[80dvh]"),
          children: [false && _jsxs("button", {
            onClick: navigateBack,
            className: "flex items-center gap-2 px-6 py-4 text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-white",
            children: [_jsxs("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [_jsx("path", {
                d: "M15.8337 10H4.16699",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }), _jsx("path", {
                d: "M10.0003 15.8334L4.16699 10L10.0003 4.16669",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              })]
            }), _jsx("span", {
              className: "font-inter text-sm font-semibold",
              children: "Back"
            })]
          }), _jsx("div", {
            className: "flex-1",
            children: renderContent()
          }), _jsx(AnimatePresence, {
            children: !headerMode && toasts.length > 0 && _jsx(motion.div, {
              initial: {
                height: 0
              },
              animate: {
                height: "auto"
              },
              exit: {
                height: 0
              },
              transition: {
                duration: 0.3,
                ease: "easeInOut"
              },
              className: "toast-section relative z-10 overflow-hidden bg-white dark:border-neutral-800 dark:bg-neutral-900",
              children: _jsx(motion.div, {
                initial: {
                  opacity: 0,
                  y: -10
                },
                animate: {
                  opacity: 1,
                  y: 0
                },
                exit: {
                  opacity: 0,
                  y: -10
                },
                transition: {
                  duration: 0.2,
                  delay: 0.1
                },
                className: "p-4 pt-0",
                children: _jsx(ToastContainer, {
                  toasts,
                  onDismiss: removeToast,
                  theme
                })
              })
            })
          })]
        })]
      }), isOpen && !isAnySpendType && _jsx("style", {
        children: `
          .modal-inner-content {
            transition: margin-bottom 0.3s ease-in-out;
            margin-bottom: ${toasts.length > 0 ? "0px" : "23px"} !important;
          }
        `
      }), contentType?.type === "avatarEditor" && _jsx("button", {
        onClick: () => setB3ModalOpen(false),
        className: "fixed right-5 top-5 z-[100] cursor-pointer text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white",
        children: _jsx("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: _jsx("path", {
            d: "M18 6L6 18M6 6L18 18",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        })
      })]
    });
    $[2] = contentType;
    $[3] = headerMode;
    $[4] = isMobile;
    $[5] = isOpen;
    $[6] = navigateBack;
    $[7] = removeToast;
    $[8] = setB3ModalOpen;
    $[9] = theme;
    $[10] = toasts;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
function _temp5(e) {
  return e.preventDefault();
}
function _temp4(state_2) {
  return state_2.navigateBack;
}
function _temp3(state_1) {
  return state_1.contentType;
}
function _temp2(state_0) {
  return state_0.setB3ModalOpen;
}
function _temp(state) {
  return state.isOpen;
}